import React, { useReducer, useContext } from "react";
import axios from 'axios';
// import Fade from 'react-reveal/Fade';

import CONSTS from "./components/faq-search-constants";


function faqHandler(faqState, action) {
    console.log("State: ", faqState, "Action: ", action);
    switch (action.type) {

        case CONSTS.UPDATE_SEARCH_FIELD:
            if (faqState.searchHintsTimer) {
                clearTimeout(faqState.searchHintsTimer);
            }

            return {...faqState, searchPhrase:action.value, searchHintsTimer:setTimeout( function (e) {
                    action.callback(action.value);
            },200)};

        case CONSTS.SEARCH_HINTS_LOADING:
            return {...faqState, searchHintsLoading: action.loading};

        case CONSTS.UPDATE_HINTS:
            return {...faqState, searchHints: action.hints};

        case CONSTS.SEARCH_REASULTS:
            return {...faqState, searchResults: [...faqState.searchHints]};

        case CONSTS.FOCUS:
            return {...faqState, focused: action.focus};
    }
}

const initialState = {
    searchPhrase:'',
    searchHints:[],
    searchHintsLoading:false,
    searchResults:[],
    focused:false
};

function FAQSearch(props) {
    const [faqState, doAction] = useReducer(faqHandler, initialState);

    let searchFieldRef = React.createRef();

    function doAjax(eventData, actionName, formData, ajaxSuccessCallback) {
        uiAction({type:CONSTS.ACTION_LOADING, eventData});


    }

    function pullNewHints(search) {
        doAction({type:CONSTS.SEARCH_HINTS_LOADING, loading:true});

        console.log("Search phrase: ", search);
        let formData = {
            search: search
        };

        axios.post('/faqsearch', formData)
            .then(function (response) {
                // console.log(response);
                switch (response.data.status) {
                    case 'OK':
                        doAction({type:CONSTS.UPDATE_HINTS, hints:response.data.data});
                        break;
                    case 'ERROR':
                        doAction({type:CONSTS.UPDATE_HINTS, hints:[]});
                        break;
                }
            })
            .catch(function (error) {
                doAction({type:CONSTS.UPDATE_HINTS, hints:[]});
            })
            .then(() => { //ALWAYS
                doAction({type:CONSTS.SEARCH_HINTS_LOADING, loading:false});
            })
        ;
    }

    function onSearchFieldChange(e) {
        doAction({type:CONSTS.UPDATE_SEARCH_FIELD, value:e.target.value, callback:pullNewHints});
    }

    function onSearchSubmit(e) {
        e.preventDefault();
        console.log('Submitted', e);
        doAction({type:CONSTS.SEARCH_REASULTS});
        searchFieldRef.current.blur();
    }


    return  (
        <div className="faq-search col-8 offset-2">
            <form autocomplete="off" className={(faqState.searchHintsLoading) ? 'loading' : ''} onSubmit={onSearchSubmit}>
                <input
                    type="text"
                    name="search"
                    className="search-field"
                    onChange={e => onSearchFieldChange(e)}
                    onBlur={e => doAction({type:CONSTS.FOCUS, focus:false})}
                    onFocus={e => doAction({type:CONSTS.FOCUS, focus:true})}
                    ref={searchFieldRef}
                    value={faqState.searchPhrase}
                    placeholder="search REV help" />
                <button type="submit">Submit</button>
            </form>

            <ul className={"search-hints " + ((faqState.focused) ? 'focused' : '')}   onMouseDown={e => e.preventDefault()}>
                {faqState.searchHints.slice(0,5).map((hint, i) => {
                    return (
                        <li className="hint layout-item">
                            <a href={hint.zendesk_url} target="_blank">{hint.post_title} <span className="category-name has-grey-color">| {hint.category_name}</span></a>
                        </li>
                    )
                })}
            </ul>

            {(faqState.searchResults.length > 0) && faqState.searchPhrase &&
            <div className="search-results">
                <h4>Search results for <em>"{faqState.searchPhrase}"</em></h4>
                {faqState.searchResults.map((item, i) => {
                    return (
                        <div className="item layout-item">
                            <a href={item.zendesk_url} target="_blank"><strong>{item.post_title} <span className="category-name has-grey-color">| {item.category_name}</span></strong></a><br />
                            <a href={item.zendesk_url} >{item.post_content}</a>
                        </div>
                    )
                })}
                <p className="cta center"><a className="arrow-link" target="_blank" href={"https://cablebahamascare.zendesk.com/hc/en-us/search?utf8=%E2%9C%93&query=" + faqState.searchPhrase}>View search results about <em>"{faqState.searchPhrase}" on Help Center</em></a> </p>
            </div>
            }

        </div>
    );
}

// wp.element.render(
//     wp.element.createElement( CManager ),
//     document.getElementById( 'cmanager' )
// );


if (typeof Rev.faqSearch !== 'undefined') { //Defined only in front end. Has data for each bundle builder on a page.
    Object.keys(Rev.faqSearch).forEach(function (item) {
        wp.element.render(
            // wp.element.createElement( FAQSearch ),
            <FAQSearch id={item} />,
            document.getElementById( item )
        );
    });
}

